export const PartActionKey = 'part-action';
export const PartActionTypesKey = 'part-action-types';